import { BatchDeleteInput, FieldInstance } from "db/definitions";
import { deleteFieldInstances } from "../db/queries/fieldInstanceQueries";
import batchRemoveFieldInstances from "./batchDeleteFieldInstances";
import { handleBatchCrud } from "./handleBatchCrud";

/**
 * Batches and deletes field instances.
 * @param {[Object]} rowsArray of objects containing the id: fieldInstanceToDelete.id
 * @param {Boolean} online status
 * @returns boolean for success.
 */
async function deleteRows(rowsArray: FieldInstance[], online: boolean) {
	if (online) {
		const batchDeleteInput: BatchDeleteInput[] = rowsArray.map((instance) => ({ id: instance.id }));
		await handleBatchCrud(batchDeleteInput, batchRemoveFieldInstances, 25);
	} else {
		await deleteFieldInstances(rowsArray);
	}

	return true;
}

export default deleteRows;
